export const PAGING = {
  take:10,
  pageIndex: 0,
  pageSize: 10,
  pageSizes: [5, 10, 20, 50],
};


export const SubscriptionIds =
  [
    { subscriptionId: '6281bf63-3e96-4510-8db1-de9e1654b48c', subscriptionTitle: "Subscription1" },
    { subscriptionId: '6bbb5368-43d8-444f-8e1f-167a8ed17c35', subscriptionTitle: "Subscription2" },
    { subscriptionId: 'b757a931-eb76-4c8f-90a0-6d1b91ca8ccf', subscriptionTitle: "Subscription3" },
  ]

export const RoleIds =
  [
    { roleId: '6281bf63-3e96-4510-8db1-de9e1654b48c', roleTitle: "RoleOne" },
    { roleId: '6bbb5368-43d8-444f-8e1f-167a8ed17c35', roleTitle: "RoleTwo" },
    { roleId: 'b757a931-eb76-4c8f-90a0-6d1b91ca8ccf', roleTitle: "RoleThree" },
    { roleId: '9758bf98-a665-43c0-85d2-f5ebdfe4e0e1', roleTitle: "RoleFour" },
    { roleId: '05c24974-4dd7-4ce5-8bb3-c9f0186e1997', roleTitle: "RoleFive" },
    { roleId: 'f387de1f-1f27-4da5-835b-6e6b82681cb9', roleTitle: "RoleSix" },
  ]